import React, { useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';
import { Button, Spin, Card } from 'antd';

import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";


import JvForm from './jvForm';
import Loader from '../../../../components/loader/loader';



const OpeningBalance = (props) => {

  const { api, userData, mainCurrency, accountData, wareHouseData, companyId, yearId, refData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role;
  const createdBy = parseInt(userData.id);
  const today = new Date().toISOString().split('T')[0];

  const { } = props;
  const [loadingEffect, setLoadingEffect] = useState(false);
  const [validated, setValidated] = useState(false);
  const [idRow, setIdRow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


  const [showModal, setShowModal] = useState(false);



  const openModal = (e) => {
    setShowModal(!showModal);
  }

  useEffect(() => {
    getOpeningBalance();
  }, []);

  const getOpeningBalance = async () => {
    try {
      setIsLoading(true);
      const data = {
        companyId,
        yearId,
      }
      let res = await api.get(`journalVoucher/getOpeningBalance`, { params: data });

      if (res.data.status) {
        setIdRow(res?.data?.data)
      } else {
        toast.error(res?.data?.status);
      }
    } catch (error) {
      toast.error("Failed Contact Support");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>



      <Card style={{ textAlign: 'center', width: '600px' }}>

        {isLoading &&
          <Loader />
        }

        {!isLoading &&
          <div>
            <Row>
              <p>
                The opening balance represents the initial account balance carried forward at the start of a new financial year.
                This setup is done only once at the beginning of the year to ensure accurate tracking of financial records.
              </p>
            </Row>

            <Row>
              <Col md={4}>
              </Col>
              <Col md={4}>
                <Button style={{ backgroundColor: '#23576a', color: 'white' }} onClick={openModal}>View JV</Button>
              </Col>
            </Row>
          </div>
        }
      </Card>


      <JvForm
        showModal={showModal}
        toggleModal={openModal}
        idRow={idRow}
        getOpeningBalance={getOpeningBalance}
      />



    </div >
  )
}


export default OpeningBalance;